import { KeyboardEvent, MouseEvent } from 'react';

export function handleLogoKeyDown(
    e: KeyboardEvent<HTMLElement>,
    onActivate: () => void
    ) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onActivate();
    }
}

export function handleLinkClick(
    e: MouseEvent<HTMLElement>,
    onActivate: () => void
    ) {
        e.preventDefault();
        onActivate();
}
